module.exports = {"330102001":"清波街道","330102003":"湖滨街道","330102004":"小营街道","330102008":"南星街道","330102009":"紫阳街道","330102010":"望江街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330102.json
// module id = 865
// module chunks = 0